<template>
  <div class="lg:ml-2 lg:mt-6 xl:ml-2 xl:mt-6 p-2 bg-gray-200 shadow-md">
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('HelpMain')"
    >
      <i class="material-icons md-3xl mr-2">info_outline</i>
      <p>Over de DSA</p>
    </div>
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('ExportVoorwaarden')"
    >
      <i class="material-icons md-3xl mr-2">gavel</i>
      <p>Voorwaarden gebruik data</p>
    </div>

    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('ExportStructure')"
    >
      <i class="material-icons md-3xl mr-2">description</i>
      <p>Structuur export</p>
    </div>
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('HelpFlexprops')"
      v-if="hasPermission('update flexprop schema')"
    >
      <i class="material-icons md-3xl mr-2">published_with_changes</i>
      <p>Flex Props</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpMenu",
  methods: {
    loadPage: function(page) {
      this.$router.push({ name: page });
    }
  }
};
</script>

<style></style>
